import { useState, useMemo } from 'react';
const initialState = {
    activeModal: null,
    accountInfoInitialTab: null,
    reportStatistics: null,
    fallbackPropertyBounds: null,
    readyDownloadUrl: null,
    readyDownloadId: null,
    selectedProject: null,
    selectedProjectForPayment: null,
    projectPaymentPrice: 0,
    pendingContourConfig: null,
    confirmCreateData: null,
};
export const useMapViewerModals = () => {
    const [state, setState] = useState(initialState);
    const actions = useMemo(() => ({
        openReport: (statistics, fallbackBounds) => {
            setState(prev => ({
                ...prev,
                activeModal: 'report',
                reportStatistics: statistics,
                fallbackPropertyBounds: fallbackBounds || null,
            }));
        },
        openDownload: (url, id) => {
            setState(prev => ({
                ...prev,
                activeModal: 'download',
                readyDownloadUrl: url,
                readyDownloadId: id,
            }));
        },
        openEditProject: (project) => {
            setState(prev => ({
                ...prev,
                activeModal: 'editProject',
                selectedProject: project,
            }));
        },
        openRemoveProject: (project) => {
            setState(prev => ({
                ...prev,
                activeModal: 'removeProject',
                selectedProject: project,
            }));
        },
        openSettings: (project) => {
            setState(prev => ({
                ...prev,
                activeModal: 'settings',
                selectedProject: project,
            }));
        },
        openAccount: () => {
            setState(prev => ({
                ...prev,
                activeModal: 'account',
            }));
        },
        openAccountInfo: (initialTab) => {
            setState(prev => ({
                ...prev,
                activeModal: 'accountInfo',
                accountInfoInitialTab: initialTab || null,
            }));
        },
        openLogin: () => {
            setState(prev => ({
                ...prev,
                activeModal: 'login',
            }));
        },
        openCreateProject: () => {
            setState(prev => ({
                ...prev,
                activeModal: 'createProject',
            }));
        },
        openProjectPayment: (project, price) => {
            setState(prev => ({
                ...prev,
                activeModal: 'projectPayment',
                selectedProjectForPayment: project,
                projectPaymentPrice: price,
            }));
        },
        openContourConfig: () => {
            setState(prev => ({
                ...prev,
                activeModal: 'contourConfig',
            }));
        },
        openConfirmCreate: (projectName) => {
            setState(prev => ({
                ...prev,
                activeModal: 'confirmCreate',
                confirmCreateData: { projectName },
            }));
        },
        closeModal: () => {
            setState(initialState);
        },
        closeDownload: () => {
            setState(prev => ({
                ...prev,
                activeModal: prev.activeModal === 'download' ? null : prev.activeModal,
                readyDownloadUrl: null,
                readyDownloadId: null,
            }));
        },
        switchAccountToLogin: () => {
            setState(prev => ({
                ...prev,
                activeModal: 'login',
            }));
        },
        setProjectPaymentData: (project, price) => {
            setState(prev => ({
                ...prev,
                selectedProjectForPayment: project,
                projectPaymentPrice: price,
            }));
        },
        setPendingContourConfig: (config) => {
            setState(prev => ({
                ...prev,
                pendingContourConfig: config,
            }));
        },
    }), []);
    return [state, actions];
};
